import { CellClickedEvent, GridOptions } from '@ag-grid-community/core';

import { LocalStorageKey } from '@shared/constants/localStorageKey';

import { qcAttributesColumnGroup } from './qc-attributes-column-group';
import { QuarterCloseGridConfigContext } from './qc-grid-config-context';
import { DEFAULT_MONTH_CLOSE_GRID_CONFIG } from './qc-grid-default-config';
import { qcMonthColumns } from './qc-month-columns';
import { qcQuarterStartColumnGroup } from './qc-quarter-start-column-group';
import { qcQuarterSummaryColumnGroup } from './qc-quarter-summary-column-group';
import { qcVendorContractColumnGroup } from './qc-vendor-contract-column-group';
import { QCGridData } from '../../../../period-close.model';
import { QuarterCloseService } from '../../quarter-close.service';

export const quarterCloseGridConfig = (
  ctx: QuarterCloseGridConfigContext,
  quarterCloseService: QuarterCloseService,
  openReviewNotesModal: (params: CellClickedEvent) => Promise<void>
): GridOptions<QCGridData> => {
  const config = DEFAULT_MONTH_CLOSE_GRID_CONFIG;

  const isFluxAnalysisAvailableAndOn =
    localStorage.getItem(LocalStorageKey.FLUX_ANALYSIS_MODE) === 'true' &&
    quarterCloseService.isFluxAnalysisAvailable();

  return <GridOptions<QCGridData>>{
    ...config,
    columnDefs: [
      qcVendorContractColumnGroup(
        ctx,
        quarterCloseService,
        isFluxAnalysisAvailableAndOn,
        openReviewNotesModal
      ),
      qcAttributesColumnGroup(ctx, isFluxAnalysisAvailableAndOn),
      qcQuarterStartColumnGroup(ctx, isFluxAnalysisAvailableAndOn),
      ...qcMonthColumns(ctx, quarterCloseService, isFluxAnalysisAvailableAndOn),
      qcQuarterSummaryColumnGroup(ctx, isFluxAnalysisAvailableAndOn),
    ],
  };
};
